@defer (on immediate) {
	<gallery [items]="pictures" [autoplay]="true" [autoplayInterval]="30*1000">
		<gallery-nav/>
		<ng-template galleryItemDef let-item let-active="active">
			@if (item.type==='video') {
				<video [appVideoActive]="active" [src]="item.src" [poster]="item.poster" muted loop playsinline></video>
			} @else {
				<img galleryImage [src]="item.src" [alt]="item.alt">
			}
		</ng-template>
	</gallery>
} @placeholder {
	<div class="visually-hidden">
		@for (picture of pictures; track picture.src; let first=$first) {
			@if (picture.type==='image') {
				<img [ngSrc]="picture.src" [width]="picture.width" [height]="picture.height" [priority]="first" alt="Bendita">
			} @else if (picture.type==='video') {
				<video [src]="picture.src" [poster]="picture.poster"></video>
			}
		}
	</div>
}
<mat-card>
	<mat-card-content class="home-content">
		@if (productHistoryCart().length>0) {
			<div class="slider-header">
				<span class="slider-header-text app-20" i18n="@@index-keep-shopping|Header above slider of recently viewed/purchased products">Sigue comprando:</span>
			</div>
		}
		<app-products-slider
			[products]="productHistoryCart()"
			[productsLoading]="productHistoryCartLoading()"
			[productsError]="productHistoryCartError()"
			[submitButtonActive]="submitButtonActive()"
			(submitButtonActiveO)="submitButtonActive.set($event)"
			(fetchMoreProducts)="fetchMoreProductHistoryCart()"
		></app-products-slider>
		@if (productHistory().length>0 && productHistoryCart().length===0) {
			<div class="slider-header">
				<span class="slider-header-text app-20" i18n="@@index-keep-shopping|Header above slider of recently viewed/purchased products">Sigue comprando:</span>
			</div>
		}
		@if (authenticationService.user() && productHistoryCart().length===0) {
			<app-products-slider
				[products]="productHistory()"
				[productsLoading]="productHistoryLoading()"
				[productsError]="productHistoryError()"
				[submitButtonActive]="submitButtonActive()"
				(submitButtonActiveO)="submitButtonActive.set($event)"
				(fetchMoreProducts)="fetchMoreProductHistory()"
			></app-products-slider>
		}
		<div class="details-container">
			<mat-card class="details-card">
				<mat-card-header>
					<mat-card-title class="app-primary-color" i18n="@@index-faq-title|Title for FAQ-about-cultivation card on home page">Preguntas frecuentes sobre cultivo</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<p i18n="@@index-faq-description|Description for FAQ-about-cultivation card on home page">Conoce las inquietudes y características más comunes sobre el cultivo y las prácticas más efectivas.</p>
					<a [routerLink]="['/blog']" i18n="@@index-learn-more|Learn more link to blog from FAQ card on home page">Aprender más</a>
				</mat-card-content>
			</mat-card>
			<mat-card class="details-card">
				<mat-card-header>
					<mat-card-title class="app-primary-color" i18n="@@index-consulting-title|Title for personalized consulting card on home page">Reservar una asesoría personalizada</mat-card-title>
				</mat-card-header>
				<mat-card-content>
					<p i18n="@@index-consulting-description|Description for personalized consulting card on home page">Agenda tu asesoría online para que logres todas tus expectativas evitando los errores más comunes del cultivo.</p>
					<a href="https://wa.me/{{environment.contact.phone.replace('+','')}}" target="_blank" i18n="@@index-book-now|WhatsApp link to book a consulting session from home page">Reservar ahora</a>
				</mat-card-content>
			</mat-card>
		</div>
		<div class="slider-header">
			<span class="slider-header-text app-20" i18n="@@index-recommended|Header for recommended products slider on home page">Recomendados:</span>
			<a class="slider-header-link" [routerLink]="productsUrlTree">
				<span i18n="@@index-see-more|See more link next to recommended products slider header">Ver más</span>
				<mat-icon>arrow_forward</mat-icon>
			</a>
		</div>
		<app-products-slider
			[products]="products()"
			[productsLoading]="productsLoading()"
			[productsError]="productsError()"
			[submitButtonActive]="submitButtonActive()"
			(submitButtonActiveO)="submitButtonActive.set($event)"
			[urlTree]="productsUrlTree"
			(fetchMoreProducts)="fetchMoreProducts()"
		></app-products-slider>
		<div class="specialty-container-fixed">
			<div class="specialty-container">
				<mat-card class="specialty-card">
					<mat-card-header>
						<mat-icon mat-card-avatar class="specialty-icon">inventory_2</mat-icon>
						<mat-card-title class="specialty-title" i18n="@@index-specialty-shipping-title|Title for nationwide shipping specialty card on home page">ENVÍOS A TODO COLOMBIA</mat-card-title>
					</mat-card-header>
					<mat-card-content class="specialty-content" i18n="@@index-specialty-shipping-description|Description for nationwide shipping specialty card on home page">Hacemos envíos a todo el país y ofrecemos todos los métodos de pago online</mat-card-content>
				</mat-card>
				<mat-card class="specialty-card">
					<mat-card-header>
						<mat-icon mat-card-avatar class="specialty-icon">shopping_cart_checkout</mat-icon>
						<mat-card-title class="specialty-title" i18n="@@index-specialty-warranty-title|Title for warranty policies specialty card on home page">POLÍTICAS DE GARANTÍA</mat-card-title>
					</mat-card-header>
					<mat-card-content class="specialty-content" i18n="@@index-specialty-warranty-description|Description for warranty policies specialty card on home page">Realiza tu proceso de garantía para darte una solución satisfactoria</mat-card-content>
				</mat-card>
				<mat-card class="specialty-card">
					<mat-card-header>
						<mat-icon mat-card-avatar class="specialty-icon">support_agent</mat-icon>
						<mat-card-title class="specialty-title" i18n="@@index-specialty-consulting-title|Title for expert consulting specialty card on home page">ASESORÍAS CON EXPERTOS</mat-card-title>
					</mat-card-header>
					<mat-card-content class="specialty-content" i18n="@@index-specialty-consulting-description|Description for expert consulting specialty card on home page">Solucionamos tus dudas y te ayudamos a tener mejores resultados</mat-card-content>
				</mat-card>
				<mat-card class="specialty-card">
					<mat-card-header>
						<mat-icon mat-card-avatar class="specialty-icon">credit_score</mat-icon>
						<mat-card-title class="specialty-title" i18n="@@index-specialty-payments-title|Title for online payments specialty card on home page">PAGOS ONLINE INMEDIATOS Y SEGUROS</mat-card-title>
					</mat-card-header>
					<mat-card-content class="specialty-content" i18n="@@index-specialty-payments-description|Description for online payments specialty card on home page">No almacenamos tus datos de pago, nos respalda Mercado Pago</mat-card-content>
				</mat-card>
			</div>
		</div>
	</mat-card-content>
</mat-card>
